<template>
  <div :class="clContainer()">
    <button
      :id="id"
      :class="clSub('input', `form__input ${inputClass}`)"
      :name="name"
      :placeholder="placeholder"
      :value="data"
    >
      <slot name="append" :state="state"></slot>
    </button>
  </div>
</template>

<script>
import Base from "./Base";

export default {
  extends: Base,
  props: {
    type: {
      type: String,
      default: "text",
    },
    typeClass: {
      type: String,
      default: "input",
    },
    height: {
      type: String,
    },
  },
  data() {
    return {
      inputClass: "",
    };
  },
  methods: {
    focused() {
      this.inputClass = "focused";
      this.validate();
    },
  },
};
</script>
